<!--@format-->
<template>
    <div class="invoice-preview-popup">
        <section class="header-popup">
            <div class="invoice-actions">
                <app-button class="action-btn" :loading="loadingDownload" @click="onClickPrint">
                    Print
                    <k26-print-outline-svg />
                </app-button>
                <app-button
                    class="action-btn-redirect secondary"
                    @click="goToBillingAndPaymentsPage"
                >
                    View in Billing and Payments Page
                    <u28-leaving-svg />
                </app-button>
            </div>
            <div class="close-btn" @click="closePopup"><s3-close-svg /></div>
        </section>

        <section class="popup-body">
            <invoice-details-section
                ref="invoiceDetailsSection"
                :account-id="accountId"
                :invoice-id="invoiceId"
                :is-funds-payer="isFundsPayer"
                invoice-mode="agency"
                :agency-id="agencyId"
                :is-mdf-mode="true"
                :actions-enabled="false"
            />
        </section>
    </div>
</template>

<script>
const InvoiceDetailsSection = () => import('@/components/account/invoice/invoice-details-section');
const K26PrintOutlinedSvg = () => import('@/components/svg/grid/k26-print-outline-svg');
const U28LeavingSvg = () => import('@/components/svg/grid/u28-leaving-svg');
const S3CloseSvg = () => import('@/components/svg/grid/s3-close-svg');
const AppButton = () => import('@/components/common/app-button');

import EventBus from '@/scripts/event-bus';
import { MdfInvoiceMixin } from '@/mixins/mdf-invoice-mixin';

export default {
    name: 'invoice-preview-popup',

    components: {
        'invoice-details-section': InvoiceDetailsSection,
        'k26-print-outline-svg': K26PrintOutlinedSvg,
        'u28-leaving-svg': U28LeavingSvg,
        's3-close-svg': S3CloseSvg,
        'app-button': AppButton,
    },

    mixins: [MdfInvoiceMixin],

    props: {
        element: {
            type: Object,
            required: true,
        },
    },

    data() {
        return { loadingDownload: false };
    },

    computed: {
        baseUrl() {
            return this.$store.getters.baseUrl;
        },

        accountId() {
            return this.$store.state.context.account.id;
        },

        invoiceId() {
            return this.element.invoiceId;
        },

        agencyId() {
            return this.$store.state.context.agency.id;
        },

        hasAgencyBillingPaymentPermission() {
            return (
                this.$store.getters.isBillingPaymentUser ||
                this.$store.getters.isOrganizationUser ||
                this.$store.getters.isMasterAgencyUser ||
                this.$store.getters.isAgencyAdmin
            );
        },

        isFundsPayer() {
            return (
                this.$store.state.user.roles.includes('FundsPayer') ||
                this.hasAgencyBillingPaymentPermission
            );
        },
    },

    created() {
        EventBus.$on('close-invoice-popup', this.closePopup);
    },

    beforeDestroy() {
        EventBus.$off('close-invoice-popup', this.closePopup);
    },

    methods: {
        onClickPrint() {
            const invoiceDetails = this.$refs.invoiceDetailsSection.invoiceDetails;
            this.printMdfInvoicePdf(invoiceDetails);
        },

        goToBillingAndPaymentsPage() {
            if (this.hasAgencyBillingPaymentPermission) {
                this.$router.push(
                    `${this.baseUrl}/Account/Billing?id=${this.invoiceId}&submenu=MDF#Invoices`,
                );
                this.closePopup();
            } else {
                this.$helpers.showFailNotification('You need permission to redirect this page.');
            }
        },

        closePopup() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.invoice-preview-popup {
    height: 100%;
    width: 100%;
}

.invoice-preview-popup .action-btn {
    width: 154px;
    height: 40px;
    gap: 10px;
}

.invoice-preview-popup .popup-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 700px;
    display: block;
}

.invoice-preview-popup .popup-body::-webkit-scrollbar {
    width: 15px;
    height: 9px;
}

.invoice-preview-popup .popup-body::-webkit-scrollbar-track {
    border-radius: 32px;
}

.invoice-preview-popup .popup-body::-webkit-scrollbar-thumb {
    background-color: #cac6cb;
    border-radius: 16px;
    border: 3px solid transparent;
    background-clip: content-box;
}

.invoice-preview-popup .invoice-details-section {
    padding-bottom: 20px;
}

.invoice-preview-popup .invoice-actions {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.invoice-preview-popup .action-btn-redirect {
    width: 300px;
}

.invoice-preview-popup .action-btn-redirect .u28-leaving-svg {
    margin-left: 10px;
}

.invoice-preview-popup .k26-print-outline-svg path {
    stroke: #ffffff;
}

.invoice-preview-popup .header-popup {
    display: flex;
    justify-content: space-between;
}

.invoice-preview-popup .close-btn {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.invoice-preview-popup .close-btn:hover {
    cursor: pointer;
    background-color: #f5d5e7;
    border-radius: 30%;
}
</style>
